import React from "react";
import { EwayBillListType } from "../../../redux/listing/listingTypes";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CircularAvatar } from "../../commons";
import { formateDateTime } from "../../../utils/commonFunctions";
import { NewDownloadIconActive, ViewIcon } from "../../../assets/images";
import { Link } from "react-router-dom";

type AppProps = {
  data: EwayBillListType[];
  tableHeaders: TableHeadersType[] | [];
};

const EwayBillTableData = ({ data, tableHeaders }: AppProps) => {
  return (
    <>
      {data?.length > 0 &&
        data?.map((item: EwayBillListType) => {
          const finalRedirectLink = {
            pathname: `/invoice-generation/edit/${item?.invoice_id}/${item?.client_code}?type=${item?.invoice_type}&client_code=${item?.client_code}&company_name=${item?.client_name}`,
          };
          return (
            <tr className="text-left">
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: TableHeadersType) => {
                  if (header?.value === "name") {
                    let finalName = `${item?.client_name} (${item?.client_code})`;
                    return (
                      <td style={{ minWidth: "200px" }} className="text-left">
                        {finalName}
                      </td>
                    );
                  } else if (header?.value === "invoice_type") {
                    return (
                      <td className="text-left" style={{ minWidth: "200px" }}>
                        {item?.invoice_type}
                      </td>
                    );
                  } else if (header?.value === "e_way_bill_no") {
                    return (
                      <td className="text-left" style={{ minWidth: "200px" }}>
                        {item?.eway_bill_number}
                      </td>
                    );
                  } else if (header?.value === "cancel_reson") {
                    return (
                      <td className="text-left" style={{ minWidth: "200px" }}>
                        {item?.reason_of_cancel ? item?.reason_of_cancel : "NA"}
                      </td>
                    );
                  } else if (header?.value === "extend_reson") {
                    return (
                      <td className="text-left" style={{ minWidth: "200px" }}>
                        {item?.extension_validity_reason
                          ? item?.extension_validity_reason
                          : "NA"}
                      </td>
                    );
                  } else if (header?.value === "status") {
                    return (
                      <td
                        className="text-left"
                        style={{ minWidth: "200px", borderRadius: "16px" }}
                      >
                        <span
                          style={{ borderRadius: "16px" }}
                          className={`${
                            item?.e_way_bill_status === 2
                              ? "status-incomplete"
                              : item?.e_way_bill_status === 1
                              ? "status-complete"
                              : "manufacturing-journal"
                          }`}
                        >
                          {item?.e_way_bill_status
                            ? item?.e_way_bill_status === 1
                              ? "Generated"
                              : item?.e_way_bill_status === 2
                              ? "Cancelled"
                              : "Extended"
                            : "NA"}
                        </span>
                      </td>
                    );
                  } else if (header?.value === "added_by") {
                    return (
                      <td className="text-left" style={{ minWidth: "200px" }}>
                        {/* {helpModuleData?.created_by?.first_name} {helpModuleData?.created_by?.last_name} */}
                        <div
                          className="ml-2"
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            gap: "7px",
                          }}
                        >
                          <CircularAvatar
                            name={`${item?.created_by?.first_name} ${item?.created_by?.last_name} `}
                            image={item?.created_by?.profile_pic?.file_url}
                          />
                          <div>
                            <span>
                              {item?.created_by?.first_name}{" "}
                              {item?.created_by?.last_name}{" "}
                            </span>

                            {item?.created_at ? (
                              <p style={{ color: "#6e7491" }}>
                                {formateDateTime(item?.created_at)}
                              </p>
                            ) : (
                              "NA"
                            )}
                          </div>
                        </div>
                      </td>
                    );
                  } else if (header?.value === "action") {
                    return (
                      <td>
                        {item?.e_way_bill_status !== 2 ? (
                          <div
                            style={{
                              textAlign: "center",
                              display: "flex",
                              alignItems: "center",
                              gap: "3%",
                            }}
                          >
                            <div>
                              <Link target="_blank" to={finalRedirectLink}>
                                <img
                                  src={ViewIcon}
                                  alt="view-icon"
                                  style={{ cursor: "pointer" }}
                                />
                              </Link>
                            </div>
                            <div>
                              <a
                              // href={
                              //   item?.e_way_bill_status === 1
                              //     ? `https://${item?.pdf_url}`
                              //     : item?.pdf_url
                              // }
                              >
                                <button
                                  className="btn form-control d-flex"
                                  style={{
                                    // border: "1px solid #dd4433",
                                    height: "34px",
                                    width: "40px",
                                  }}
                                  onClick={() =>
                                    window.open(
                                      "https://ewaybillgst.gov.in/Others/EBPrintnew.aspx",
                                      "_blank"
                                    )
                                  }
                                >
                                  <img src={NewDownloadIconActive} alt="" />
                                </button>
                              </a>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    );
                  }
                })}
            </tr>
          );
        })}
    </>
  );
};

export default EwayBillTableData;
